// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Youtube: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 23 16"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M22.52 2.503A2.875 2.875 0 0020.485.48C18.692 0 11.5 0 11.5 0S4.308 0 2.514.479A2.875 2.875 0 00.481 2.503C0 4.29 0 8.016 0 8.016s0 3.727.48 5.513c.265.985 1.044 1.729 2.034 1.992C4.308 16 11.5 16 11.5 16s7.192 0 8.986-.479c.99-.263 1.769-1.007 2.033-1.992C23 11.743 23 8.016 23 8.016s0-3.726-.48-5.513zM9.147 11.4V4.633l6.011 3.383L9.148 11.4z" />
        </svg>
    );
};

export default React.memo(Youtube);
